/**
 * Converte valor monetário (número) para extenso em português (reais e centavos).
 * @param {number} valor
 * @returns {string}
 */
export function valorPorExtenso(valor) {
  if (!valor || valor === 0) return "";

  const unidades = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
  const especiais = ["dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
  const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
  const centenas = ["", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];

  const converterGrupo = (n) => {
    if (n === 0) return "";
    if (n === 100) return "cem";

    let resultado = "";
    const c = Math.floor(n / 100);
    const d = Math.floor((n % 100) / 10);
    const u = n % 10;

    if (c > 0) resultado += centenas[c];

    if (d === 1) {
      if (resultado) resultado += " e ";
      resultado += especiais[u];
      return resultado;
    }

    if (d > 0) {
      if (resultado) resultado += " e ";
      resultado += dezenas[d];
    }

    if (u > 0) {
      if (resultado) resultado += " e ";
      resultado += unidades[u];
    }

    return resultado;
  };

  const parteInteira = Math.floor(valor);
  const centavos = Math.round((valor - parteInteira) * 100);

  if (parteInteira === 0 && centavos === 0) return "zero reais";

  let resultado = "";

  if (parteInteira > 0) {
    const bilhoes = Math.floor(parteInteira / 1000000000);
    const milhoes = Math.floor((parteInteira % 1000000000) / 1000000);
    const milhares = Math.floor((parteInteira % 1000000) / 1000);
    const resto = parteInteira % 1000;

    if (bilhoes > 0) {
      resultado += converterGrupo(bilhoes) + (bilhoes === 1 ? " bilhão" : " bilhões");
    }

    if (milhoes > 0) {
      if (resultado) resultado += " ";
      resultado += converterGrupo(milhoes) + (milhoes === 1 ? " milhão" : " milhões");
    }

    if (milhares > 0) {
      if (resultado) resultado += " ";
      if (milhares === 1) {
        resultado += "mil";
      } else {
        resultado += converterGrupo(milhares) + " mil";
      }
    }

    if (resto > 0) {
      if (resultado) resultado += " ";
      resultado += converterGrupo(resto);
    }

    resultado += parteInteira === 1 ? " real" : " reais";
  }

  if (centavos > 0) {
    if (resultado) resultado += " e ";
    resultado += converterGrupo(centavos) + (centavos === 1 ? " centavo" : " centavos");
  }

  return resultado.charAt(0).toUpperCase() + resultado.slice(1);
}

/**
 * Texto completo para o PDF (parênteses no documento), alinhado ao padrão do sistema.
 * @param {number} valor — valor total da proposta (> 0)
 * @returns {string|null}
 */
export function textoValorTotalPdf(valor) {
  const v = Number(valor);
  if (v == null || Number.isNaN(v) || v <= 0) return null;
  const ext = valorPorExtenso(v);
  if (!ext) return null;
  return `Valor global da proposta de preços: ${ext}`;
}
